/**
 * Help-center slug ↔ key mapping (Portuguese URLs).
 *
 * Single source of truth for the URL slug used in `/ajuda/<slug>` and the
 * INTERNAL i18n key used in translation lookups.
 *
 * Why two layers?
 *   - The URL slug must be PT + hyphenated (`primeiros-passos`) for SEO:
 *     mixing EN tokens on a PT path penalises rankings, and underscores
 *     are treated as a single token by Google.
 *   - The i18n key must stay stable (English) so we don't churn the
 *     translation files (`pages.help_center.categories.<key>.title`).
 *
 * The backend mirror lives at /app/backend/routes/seo_pkg/renderer.py
 * (HELP_KEY_TO_SLUG / HELP_SLUG_TO_KEY). Keep both in lockstep — adding
 * a category here without updating the backend will break SEO prerender.
 */

export const HELP_KEY_TO_SLUG = {
  getting_started: "primeiros-passos",
  account:         "conta",
  trips:           "passeios",
  routes_maps:     "rotas-mapas",
  garage:          "garagem",
  clubs:           "clubes",
  photos_media:    "fotos-multimedia",
  motri:           "motri",
  mototrips_go:    "mototrips-go",
  tools:           "ferramentas",
  plans:           "planos",
  ambassador:      "embaixador",
  social:          "social",
  security:        "seguranca",
  troubleshooting: "resolucao-problemas",
};

export const HELP_SLUG_TO_KEY = Object.fromEntries(
  Object.entries(HELP_KEY_TO_SLUG).map(([k, v]) => [v, k])
);

/**
 * Resolve a `:category` URL param to either:
 *   - { kind: "ok",       key }            — valid PT slug, render normally
 *   - { kind: "redirect", to }              — old EN slug, redirect to PT slug
 *   - { kind: "notfound" }                  — unknown slug, show 404
 *
 * `search` is the current query-string (preserved across redirect so
 * `?artigo=a3&lng=en` survives the slug migration).
 */
export function resolveHelpCategory(slug, search = "") {
  if (!slug) return { kind: "notfound" };
  if (HELP_SLUG_TO_KEY[slug]) {
    return { kind: "ok", key: HELP_SLUG_TO_KEY[slug] };
  }
  if (HELP_KEY_TO_SLUG[slug]) {
    // It's an OLD i18n key being used as a URL slug — redirect to the
    // canonical PT slug, preserving any query string.
    return { kind: "redirect", to: `/ajuda/${HELP_KEY_TO_SLUG[slug]}${search || ""}` };
  }
  return { kind: "notfound" };
}
